import Container from "@client/content/Containers/container";
import Progress from "@client/content/controls/Progress/component";
import { getContainerProps } from "@client/content/lib/helper";
import { type RootContainerProps } from "@client/content/types";
import { useDidUpdate } from "@client/lib/hooks";
import { useI18n } from "@common/hooks/i18n";
import { i18nFormat } from "@common/lib/i18n";
import * as React from "react";
import "./style.less";

export type MapProps = RootContainerProps & {
  completed: number;

  total: number;
  sectionIds: string;
};

export interface ActionProps {
  reload: () => void;
}

export default (props: ActionProps & MapProps) => {
  const i18n = useI18n();

  useDidUpdate(() => props.reload(), [props.sectionIds, props.reload]);

  return (
    <Container className="wsc_content_member_course_progress" {...getContainerProps(props)}>
      <p className="title">{i18nFormat(i18n.infoMOfNLessonsCompleted, ["M", props.completed], ["N", props.total])}</p>
      <Progress height={10} m={props.completed} n={props.total} />
    </Container>
  );
};
